function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */


import Base from './base';
import URI from 'urijs'; // @namespace Model

var ReferralCode = /*#__PURE__*/function (_Base) {
  _inheritsLoose(ReferralCode, _Base);

  function ReferralCode() {
    return _Base.apply(this, arguments) || this;
  }

  ReferralCode.initClass = function initClass() {
    this.prototype.idAttribute = 'code';
  };

  var _proto = ReferralCode.prototype;

  _proto.urlRoot = function urlRoot() {
    return '/api/referral_codes';
  };

  _proto.reminderEmailUrl = function reminderEmailUrl() {
    return URI(this.url()).segment('remind').toString();
  };

  _proto.sendReminder = function sendReminder() {
    return this.save(null, {
      url: this.reminderEmailUrl()
    });
  };

  return ReferralCode;
}(Base);

ReferralCode.initClass();
export default ReferralCode;